import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import GenericUtils from "../utils/GenericUtils";

interface RestartScrollContainerProps {
    children?: React.ReactNode;
}

function RestartScrollContainer(props: RestartScrollContainerProps) {
    const { children } = props;
    const location = useLocation();

    useEffect(() => {
        GenericUtils.restartScroll();
    }, [location]);

    return <main>{children}</main>;
}

export default RestartScrollContainer;
